import axios from "../axios-control";

export const todos = () => axios
    .get('/sedes')
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const cargaUno = id => axios
    .get(`/sedes/${id}`)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const actualiza = tipo => axios
    .put(`/sedes/${tipo.id}`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const crea = tipo => axios
    .post(`/sedes`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const eliminar = tipo => axios
    .delete(`/sedes/${tipo.id}`)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });